import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@repo/ui/components/ui/sidebar'
import { cn } from '@repo/ui/lib/utils'
import { Link, useRouterState } from '@tanstack/react-router'
import { type LucideIcon } from 'lucide-react'

export function NavMain({
  items,
}: {
  items: {
    title: string
    url: string
    group: 'operations' | 'setup' | 'business' | 'admin'
    icon?: LucideIcon
  }[]
}) {
  const pathname = useRouterState({ select: (state) => state.location.pathname })

  const isCurrent = (url: string) => pathname === url
  const sections = [
    { id: 'operations', label: 'Operations' },
    { id: 'setup', label: 'Setup' },
    { id: 'business', label: 'Business' },
    { id: 'admin', label: 'Admin' },
  ] as const

  const renderSection = (
    label: string,
    sectionItems: {
      title: string
      url: string
      group: 'operations' | 'setup' | 'business' | 'admin'
      icon?: LucideIcon
    }[]
  ) => (
    <SidebarGroup key={label} className="gap-1.5 py-2">
      <SidebarGroupLabel className="px-2 font-mono text-[10px] tracking-[0.16em] uppercase text-sidebar-foreground/56">
        {label}
      </SidebarGroupLabel>
      <SidebarMenu>
        {sectionItems.map((item) => (
          <SidebarMenuItem key={item.title}>
            <SidebarMenuButton
              asChild
              tooltip={item.title}
              className={cn(
                'rounded-[4px] border border-transparent transition-all hover:border-sidebar-border/75 hover:bg-sidebar-accent/72 active:scale-[0.985]',
                isCurrent(item.url) &&
                  'border-sidebar-border/80 bg-sidebar-accent text-sidebar-accent-foreground shadow-[var(--app-shadow-line)]'
              )}
            >
              <Link to={item.url}>
                {item.icon && <item.icon className="h-4 w-4" />}
                <span>{item.title}</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        ))}
      </SidebarMenu>
    </SidebarGroup>
  )

  return (
    <>
      {sections.map((section) => {
        const sectionItems = items.filter((item) => item.group === section.id)
        return sectionItems.length > 0 ? renderSection(section.label, sectionItems) : null
      })}
    </>
  )
}
